// import {getFromStorage} from './storage';
// import GLOBAL from './global';
import axios from 'axios';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

let domain;

if (process.env.NODE_ENV === 'production') {
  domain = 'https://internshipmanagerbackend.herokuapp.com/';
} else {
  domain = 'http://localhost:8080/';
}

const requests = {
  'POST_REGISTER': domain + 'signup',
  'POST_SIGNIN': domain + 'signin',
  'POST_ACTIVATION': domain + 'activation',
  'POST_SIGNOUT': domain + 'signout',
  'POST_DIRECT_PASSWORD_UPDATE': domain + 'users/:hashedID/password-recovery/direct',
  'POST_EDIT_ACCOUNT_DETAILS': domain + 'users/:hashedID/profile/edit',
  'GET_USER_EDITABLE_DATA': domain + 'users/:hashedID/profile/editable',
  'GET_INTERESTED_STUDENTS': domain + 'users/:hashedID/students/interested',
  'GET_USER_FAVORITES': domain + 'users/:hashedID/favorites',
  'GET_NUMBER_UNVALIDATED_OFFERS': domain + 'admin/:hashedID/unvalidated-offers/number',
  'POST_NEW_FAVORITE': domain + 'users/:hashedID/favorites/:offerHashedId/add',
  'POST_DELETE_FAVORITE': domain + 'users/:hashedID/favorites/:offerHashedId/delete',
  'GET_OFFERS': domain + 'offers/:hashedID/all',
  'GET_UNVALIDATED_OFFERS': domain + 'admin/:hashedID/offers/unvalidated',
  'POST_ISINTERESTED': domain + 'users/:hashedID/is-interested',
  'GET_OFFER_DETAILS': domain + 'offers/:hashedID/offer/:offerID',
  'GET_MY_APPLICATIONS': domain + 'users/:hashedID/applications',
  'POST_DELETE_APPLICATION': domain + 'users/:hashedID/offers/:offerHashedID/delete',
  'POST_OFFER': domain + 'offers/:hashedID/create',
  'POST_VALIDATE_OFFER': domain + 'admin/:hashedID/offers/validate',
  'POST_APPLY_TO_OFFER': domain + 'offers/:hashedID/offer/:offerHashedID/apply',
  'POST_DELETE_POST': domain + 'offers/:hashedID/offer/:offerHashedID/delete',
  'POST_PROFILE_PICTURE': domain + 'users/:hashedID/profile-picture/upload',
  'POST_REMOVE_PROFILE_PICTURE': domain + 'users/:hashedID/profile-picture/remove',
  'POST_CV': domain + 'users/:hashedID/cv/upload',
  'GET_COMPANIES': domain + 'companies/:hashedID/all',
  'GET_COMPANY_DETAILS': domain + 'companies/:hashedID/company/:companyID',
  'POST_NEW_COMPANY': domain + 'companies/:hashedID/create',
  'GET_ACCOUNT_INFO': domain + 'users/:hashedID/profile/my',
  'GET_PROFILES': domain + 'users/:hashedID/profiles/',
  'GET_MY_OFFERS': domain + 'offers/:hashedID/my',
  'GET_CAREER_TIPS': domain + 'tips/:hashedID/my',
  'POST_NEW_TIP': domain + 'tips/:hashedID/create',
  'GET_DASHBOARD_DATA': domain + 'admin/:hashedID/dashboard',
  'OFFICE_SIGNIN': domain + 'signin/office',
  'OFFICE_SIGNUP': domain + 'signup/office'
};


function SignInAPIReq(identity, password){
  let URL_READY = requests['POST_SIGNIN'];

  return axios.post(URL_READY,{
    identity,
    password
  })
    .then((res) => {
      let {data} = res;
      if(data.status === 'success'){
        // console.log('Logged in');

        cookies.set('auth', data.data.appToken.value, { path: '/' });
        cookies.set('hashedID', data.data.hashed_id, { path: '/' });
        cookies.set('firstName', data.data.first_name, { path: '/' });
        cookies.set('lastName', data.data.last_name, { path: '/' });
        cookies.set('school', data.data.school, { path: '/' });
        cookies.set('isAlumni', data.data.is_alumni, { path: '/' });
        cookies.set('isAdmin', data.data.is_admin, { path: '/' });
        cookies.set('profilePicture', data.data.profile_picture, { path: '/' });

        return [data.data.appToken.value, data.data.hashed_id];

      }
      else{
        //navigate to home screen: this.props.history.push();
        // console.log('Didnt log in :/');
        return data.message
      }

    }).catch((err) => {
      return err.response.data
    });
}

function SignInOfficeAPIReq(identity){
  let URL_READY = requests['OFFICE_SIGNIN'];

  return axios.post(URL_READY,{
    identity
  })
    .then((res) => {
      // console.log(res)
      let {data} = res;
      if(data.data.is_registered === true){
        // console.log('Logged in');

        // cookies.set('auth', data.data.appToken.value, { path: '/' });
        cookies.set('hashedID', data.data.hashed_id, { path: '/' });
        cookies.set('firstName', data.data.first_name, { path: '/' });
        cookies.set('lastName', data.data.last_name, { path: '/' });
        cookies.set('school', data.data.school, { path: '/' });
        cookies.set('isAlumni', data.data.is_alumni, { path: '/' });
        cookies.set('profilePicture', data.data.profile_picture, { path: '/' });
        // console.log(data.data.appToken.value)

        return {status: 'registered', data: [data.data.appToken.value, data.data.hashed_id]}
        

      }
      else {
      
        //navigate to home screen: this.props.history.push();
        // console.log('Didnt log in :/');
        return res.data
      }

    }).catch((error) => {
      return error.response.data
    });
}

function SignUpAPIReq(aui_id, first_name, last_name, email, phone_number, gender, school, major, minor, current_job, linkedin_username, github_username, is_alumni, password ){
  let URL_READY = requests['POST_REGISTER'];
  return axios.post(URL_READY, {
    aui_id,
    first_name,
    last_name,
    email,
    phone_number,
    gender,
    school,
    major,
    minor,
    current_job,
    linkedin_username,
    github_username,
    is_alumni,
    password
  })
    .then((res) => {
      let {data} = res;
      if(data.status === 'success'){

        cookies.set('activationToken', data.data.activationToken, { path: '/' });

        return data.data.activationToken;

      }
      else{
        //navigate to home screen: this.props.history.push();
        alert(data.message);
        return null
      }

    }).catch((err) => {
      return err.response.data
    });
}

function SignUpOfficeAPIReq(aui_id, office_id, 
  first_name, last_name, phone_number, gender, school, major, 
  concentration, minor, is_alumni){
  let URL_READY = requests['OFFICE_SIGNUP'];
  return axios.post(URL_READY, {
    aui_id,
    first_name,
    last_name,
    phone_number,
    office_id,
    gender,
    school,
    concentration,
    major,
    minor,
    is_alumni,
  })
    .then((res) => {
      let {data} = res;
      if(data.status === 'success'){

        cookies.set('auth', data.data.appToken.value, { path: '/' });
        cookies.set('hashedID', data.data.hashed_id, { path: '/' });
        cookies.set('firstName', data.data.first_name, { path: '/' });
        cookies.set('lastName', data.data.last_name, { path: '/' });
        cookies.set('school', data.data.school, { path: '/' });
        cookies.set('isAlumni', data.data.is_alumni, { path: '/' });

      }
      else{
        //navigate to home screen: this.props.history.push();
        alert(data.message);
        return null
      }

    }).catch((err) => {
      console.error(err)
    });
}

function ActivateAccountAPIReq(activationCode){
  let URL_READY = requests['POST_ACTIVATION'];

  return axios.post(URL_READY,{
    activationCode,
    activationToken: cookies.get('activationToken')
  })
    .then((res) => {
      let {data} = res;
      if(data.status === 'success'){
        // console.log('activated');

        return res;
      }
      else{
        //navigate to home screen: this.props.history.push();
        alert('Invalid Activation Code');
        return null
      }

    }).catch((err) => {
      console.error(err)
    });
}

function GetInterestedStudentsAPIReq(){
  let URL_READY = requests['GET_INTERESTED_STUDENTS'].replace(':hashedID', cookies.get('hashedID'));

  return axios.get(URL_READY,{
    headers: {
      auth: cookies.get('auth')
    },
    params:{
    }
  })
    .then((res) => {
      // console.log(res)
      let {data} = res;
      // console.log(data.status === 'success');
      if(data.status === 'success'){
        return [0, data.data];
      }
      else{
        //navigate to home screen: this.props.history.push();
        alert('Couldn\'t Get the student\'s data');
        return [1, data.message];

      }

    }).catch((err) => {
      if(err.response.data.error.code === 6){
        return [2, err.response.data.error.message] ;
      }
      console.error(err);
    });
}


function GetAccountInfo(){
  let url = requests['GET_ACCOUNT_INFO'].replace(':hashedID', cookies.get('hashedID'));
  return axios.get(url,{
    headers: {
      auth: cookies.get('auth')
    },
    params:{
    }
  })
    .then((res) => {
      let {data} = res;
      if(data.status === 'success'){
        return [0, data.data];
      }
      else{
        alert('Couldn\'t Get the student\'s data');
        return [1, data.message];
      }

    }).catch((err) => {
      if(err.response.data.error.code === 6){
        return [2, err.response.data.error.message] ;
      }
      console.error(err);
    });
}


function getOffers(history) {
  let url = requests['GET_OFFERS'].replace(':hashedID', cookies.get('hashedID'));
  // console.log("get offer", url)
  return axios.get(url, {
    headers: {
      auth: cookies.get('auth')
    }
  })
    .then((res) => {
      // console.log(res.data.data);
      return res.data.data;

    }).catch((err) => {
      // console.log(err);
      return err.response.data.error.code;
    });
}
function getUnvalidatedOffers(history) {
  let url = requests['GET_UNVALIDATED_OFFERS'].replace(':hashedID', cookies.get('hashedID'));
  // console.log("get offer", url)
  return axios.get(url, {
    headers: {
      auth: cookies.get('auth')
    }
  })
    .then((res) => {
      // console.log(res.data.data);
      return res.data.data;

    }).catch((err) => {
      // console.log(err);
      return err.response.data.error.code;
    });
}

function getMyOffers(history) {
  let url = requests['GET_MY_OFFERS'].replace(':hashedID', cookies.get('hashedID'));
  return axios.get(url, {
    headers: {
      auth: cookies.get('auth')
    }
  })
    .then((res) => {
      // console.log(res.data.data);
      return res.data.data;

    }).catch((err) => {
      if(err.response.data.error.code === 6){
        history.push('/sign-in')
      }
      console.error(err)
      return err;
    });
}
function getMyApplications(history) {
  let url = requests['GET_MY_APPLICATIONS'].replace(':hashedID', cookies.get('hashedID'));
  // console.log(url);
  return axios.get(url, {
    headers: {
      auth: cookies.get('auth')
    }
  })
    .then((res) => {
      // console.log(res.data.data);
      return res.data.data;

    }).catch((err) => {
      if(err.response.data.error.code === 6){
        history.push('/sign-in')
      }
      console.error(err)
      return err;
    });
}

function getDashboardData(history) {
  let url = requests['GET_DASHBOARD_DATA'].replace(':hashedID', cookies.get('hashedID'));
  console.log(url);
  console.log(cookies.get('auth'))
  return axios.get(url, {
    headers: {
      auth: cookies.get('auth')
    }
  })
    .then((res) => {
      // console.log(res.data.data);
      return res.data.data;

    }).catch((err) => {
      if(err.response.data.error.code === 6){
        history.push('/sign-in')
      }
      console.error(err)
      return err;
    });
}

function getOfferDetailsAPIReq(id) {
  let url = requests['GET_OFFER_DETAILS'].replace(':hashedID', cookies.get('hashedID'));
  url = url.replace(':offerID', id);
  // console.log("get offer: ", url)
  return axios.get(url, {
    headers: {
      auth: cookies.get('auth')
    }
  })
    .then((res) => {
      // console.log(res.data.data);
      return res.data.data;

    }).catch((err) => {
      console.error(err)
      return err;
    });
}

function getCompanyDetailsAPIReq(id) {
  let url = requests['GET_COMPANY_DETAILS'].replace(':hashedID', cookies.get('hashedID'));
  url = url.replace(':companyID', id);
  return axios.get(url, {
    headers: {
      auth: cookies.get('auth')
    }
  })
    .then((res) => {
      // console.log(res.data.data);
      return res.data.data;

    }).catch((err) => {
      console.error(err)
      return err;
    });
}

function postOfferAPIReq(offer, history){
  let url = requests['POST_OFFER'].replace(':hashedID', cookies.get('hashedID'));
  // console.log(url)
  // console.log(offer)
  return axios.post(url, {
    offer,
  }, {
    headers: {
      auth: cookies.get('auth')
    }, 
  })
    .then((res) => {
      // console.log(res)
      // console.log(res.data.data);
      return res.data.data;

    }).catch((err) => {
      if(err.response.data.error.code === 6){
        history.push('/sign-in')
      }
      console.error(err.response);
      return err.response.data;
    });
}

function postCompanyAPIReq(company, image) {
  // console.log(image)
  let bodyFormData = new FormData();

  bodyFormData.set('company[name]', company.name);
  bodyFormData.set('company[industry]', company.industry);
  bodyFormData.set('company[website]', company.website);
  bodyFormData.set('company[location]', company.location);

  bodyFormData.append('image', image); 

  let url = requests['POST_NEW_COMPANY'].replace(':hashedID', cookies.get('hashedID'));

  return axios.post(url, bodyFormData, {
    headers: {
      auth: cookies.get('auth'),
      'Content-Type': 'multipart/form-data'
    },
  })
    .then((res) => {
      // console.log(res.data.data);
      return res.data.data;

    }).catch((err) => {
      // console.error(err.response)
      return err.response.data;
    });
  
}

function postTipCreationAPIReq(tip, image) {
  // console.log(image)
  let bodyFormData = new FormData();

  bodyFormData.set('title', tip.title);
  bodyFormData.set('description', tip.description);

  bodyFormData.append('image', image);


  let url = requests['POST_NEW_TIP'].replace(':hashedID', cookies.get('hashedID'));
  console.log(url)
  return axios.post(url, bodyFormData, {
    headers: {
      auth: cookies.get('auth'),
      'Content-Type': 'multipart/form-data'
    },
  })
    .then((res) => {
      // console.log(res.data.data);
      return res.data.data;

    }).catch((err) => {
      // console.error(err.response)
      return err.response.data;
    });

}

function getCompaniesAPIReq() {
  let url = requests['GET_COMPANIES'].replace(':hashedID', cookies.get('hashedID'));

  return axios.get(url, {
    headers: {
      auth: cookies.get('auth')
    }
  })
    .then((res) => {
      // console.log(res.data.data);
      return res.data.data;

    }).catch((err) => {
      // console.error(err)
      return err;
    });
}

function getUserEditableDataAPIReq() {
  let url = requests['GET_USER_EDITABLE_DATA'].replace(':hashedID', cookies.get('hashedID'));
  // console.log(url)
  return axios.get(url, {
    headers: {
      auth: cookies.get('auth')
    }
  })
    .then((res) => {
      let {data} = res;
      if(data.status === 'success'){
        return [true, data.data];
      }
      else{
        //navigate to home screen: this.props.history.push();
        return [false, data.message];
      }

    }).catch((err) => {
      console.error(err)
      return err;
    });
}

function postUserEditableDataAPIReq(first_name, last_name, phone_number, school, major, minor, gender, current_job, cv_url, linkedin_username, github_username) {
  let url = requests['POST_EDIT_ACCOUNT_DETAILS'].replace(':hashedID', cookies.get('hashedID'));
  // console.log(url);
  return axios.post(url, {
    first_name,
    last_name,
    phone_number,
    school,
    major,
    minor,
    gender,
    current_job,
    cv_url,
    linkedin_username,
    github_username
  }, {
    headers: {
      auth: cookies.get('auth')
    },
  })
    .then((res) => {
      let {data} = res;
      // console.log(res);
      return data.status === 'success';

    }).catch((err) => {
      // console.error(err)
      return err;
    });

}
function postValidateOffer(postID) {
  let url = requests['POST_VALIDATE_OFFER'].replace(':hashedID', cookies.get('hashedID'));
  console.log(postID);
  return axios.post(url, {
    postID,
  }, {
    headers: {
      auth: cookies.get('auth')
    },
  })
    .then((res) => {
      let {data} = res;
      // console.log(res);
      return data.status === 'success';

    }).catch((err) => {
      // console.error(err)
      return err;
    });

}

function postRejectOffer(postID) {
  let url = requests['POST_VALIDATE_OFFER'].replace(':hashedID', cookies.get('hashedID'));
  // console.log(url);
  return axios.post(url, {
    postID,
  }, {
    headers: {
      auth: cookies.get('auth')
    },
  })
    .then((res) => {
      let {data} = res;
      // console.log(res);
      return data.status === 'success';

    }).catch((err) => {
      // console.error(err)
      return err;
    });

}

function postDeletePostAPIReq(offerHashedID) {
  let url = requests['POST_DELETE_POST'].replace(':hashedID', cookies.get('hashedID'));
  url = url.replace(':offerHashedID',offerHashedID);

  return axios.post(url, {
  }, {
    headers: {
      auth: cookies.get('auth')
    },
  })
    .then((res) => {
      let {data} = res;
      // console.log(data.status);
      return data.status === 'success';

    }).catch((err) => {
      // console.error(err.response);
      return false;
    });

}

function directPasswordUpdateAPIReq(oldPassword, newPassword, newPasswordConfirmation) {
  let url = requests['POST_DIRECT_PASSWORD_UPDATE'].replace(':hashedID', cookies.get('hashedID'));
  // console.log(oldPassword, ' ', newPassword, ' ', newPasswordConfirmation )
  return axios.post(url, {
    oldPassword,
    newPassword,
    passwordConfirmation: newPasswordConfirmation,
  }, {
    headers: {
      auth: cookies.get('auth')
    },
  })
    .then((res) => {
      return res.data.status === 'success';

    }).catch((err) => {
      console.error(err.response)
      alert('An error has occured');
      return err;
    });

}

function postIsInterestedUpdate(is_interested) {
  let url = requests['POST_ISINTERESTED'].replace(':hashedID', cookies.get('hashedID'));
  return axios.post(url, {
    is_interested
  }, {
    headers: {
      auth: cookies.get('auth')
    },
  })
    .then((res) => {
      // console.log(res)
      return res.data.status === 'success';

    }).catch((err) => {
      // console.error(err.response)
      alert('An error has occured');
      return null;
    });

}

function SignOutAPIReq () {
  let url = requests['POST_SIGNOUT']

  // console.log(url)
  return axios.post(url, {},{
    headers: {
      auth: cookies.get('auth')
    }
  })
    .then((res) => {
      let {data} = res;
      if(data.status === 'success'){
        return data.success.code;
        // history.push('/sign-in')
      }
      else{
        //navigate to home screen: this.props.history.push();
        return [false, data.message];
      }

    }).catch((err) => {
      console.error(err)
      return err;
    });
}

function getProfilesDetailsAPIReq(hashedIDs){
  let url = requests['GET_PROFILES'].replace(':hashedID', cookies.get('hashedID'));
  return axios.post(url, {
    hashedIDs,
  }, {
    headers: {
      auth: cookies.get('auth')
    },
  })
    .then((res) => {
      // console.log('response:',res);
      return res.data.data;

    }).catch((err) => {
      // console.error(err)
      return err;
    });
}

function postRemoveProfilePictureAPIReq(){
  let url = requests['POST_REMOVE_PROFILE_PICTURE'].replace(':hashedID', cookies.get('hashedID'));
  return axios.post(url, {},{
    headers: {
      auth: cookies.get('auth')    
    }
  })
  .then((res) => {
    // console.log('response:',res);
    cookies.set('profilePicture', '')
    return res.data.status === 'success';
    

  }).catch((err) => {
    console.error(err.response)
    return err.response.data;
  });
}

function postChangeProfilePictureAPIReq(image, setUploadProgress){
  let url = requests['POST_PROFILE_PICTURE'].replace(':hashedID', cookies.get('hashedID'));
  // console.log(image)
  let formData = new FormData();
  formData.append('image',image);
  return axios.post(url,formData, {
    headers: {
      auth: cookies.get('auth'),
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress: (ev) => {
      const progress = ev.loaded / ev.total * 100;
      setUploadProgress(Math.round(progress));
      if(progress===100)
        setUploadProgress(0);
    },
  })
    .then((res) => {
      // console.log('response:',res);
      cookies.set('profilePicture', res.data.data)
      return res.data.status === 'success';
      

    }).catch((err) => {
      console.error(err.response)
      return err.response.data;
    });
}

function postChangeCVAPIReq(file, setUploadProgress){
  let url = requests['POST_CV'].replace(':hashedID', cookies.get('hashedID'));
  let formData = new FormData();
  formData.append('file',file);
  return axios.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      auth: cookies.get('auth')
    },
    onUploadProgress: (ev) => {
      const progress = ev.loaded / ev.total * 100;
      setUploadProgress(Math.round(progress));
      if(progress===100)
        setUploadProgress(0);
    },
  })
    .then((res) => {
      // console.log('response:',res);
      return res.data.status === 'success';

    }).catch((err) => {
      console.error(err)
      return err;
    });
}

function postApplyToOfferAPIReq(offer, motivation_letter){
  let url = requests['POST_APPLY_TO_OFFER'].replace(':hashedID', cookies.get('hashedID'));
  url = url.replace(':offerHashedID', offer.hashed_id);
  // console.log(url)
  return axios.post(url, {
    motivation_letter
  }, {
    headers: {
      auth: cookies.get('auth')
    },
  })
    .then((res) => {
      // console.log('response:',res);
      return res.data.status === 'success';

    }).catch((err) => {
      console.error(err)
      return err;
    });
}

function postDeleteApplications(offerHashedID){
  let url = requests['POST_DELETE_APPLICATION'].replace(':hashedID', cookies.get('hashedID'));
  url = url.replace(':offerHashedID', offerHashedID);
  // console.log(url)
  return axios.post(url, {
  }, {
    headers: {
      auth: cookies.get('auth')
    },
  })
    .then((res) => {
      // console.log('response:',res);
      return res.data.status === 'success';

    }).catch((err) => {
      // console.error(err)
      return err;
    });
}

function getFavoritesAPIReq(){
  let url = requests['GET_USER_FAVORITES'].replace(':hashedID', cookies.get('hashedID'));

  return axios.get(url, {
    headers: {
      auth: cookies.get('auth')
    }
  })
    .then((res) => {
      // console.log(res.data.data);
      return res.data;

    }).catch((err) => {
      // console.log(err);
      return err.response
    });
}

function getNumberOfNumberOffers(){
  let url = requests['GET_NUMBER_UNVALIDATED_OFFERS'].replace(':hashedID', cookies.get('hashedID'));

  return axios.get(url, {
    headers: {
      auth: cookies.get('auth')
    }
  })
    .then((res) => {
      console.log(res.data);
      return res.data;

    }).catch((err) => {
      // console.log(err);
      return err.response
    });
}

function getTipsAPICall(){
  let url = requests['GET_CAREER_TIPS'].replace(':hashedID', cookies.get('hashedID'));
  console.log(url)
  return axios.get(url, {
    headers: {
      auth: cookies.get('auth')
    }
  })
    .then((res) => {
      // console.log(res.data.data);.
      return res.data;

    }).catch((err) => {
      // console.log(err);
      return err.response
    });
}

function postAddFavoriteAPIReq(offer_id){
  let url = requests['POST_NEW_FAVORITE'].replace(':hashedID', cookies.get('hashedID'));
  url = url.replace(':offerHashedId', offer_id);
  
  return axios.post(url, {}, {
    headers: {
      auth: cookies.get('auth')
    }
  })
  .then((res) => {
      return res.data
  }).catch((err) => {
      return err.response
  })
}

function deleteFavoriteAPIReq(offer_id){
  let url = requests['POST_DELETE_FAVORITE'].replace(':hashedID', cookies.get('hashedID'));
  url = url.replace(':offerHashedId', offer_id);

  return axios.post(url, {}, {
    headers: {
      auth: cookies.get('auth')
    }
  })
  .then((res) => {
      return res.data
  }).catch((err) => {
      return err.response
  })
}

export {SignInAPIReq, postCompanyAPIReq, postAddFavoriteAPIReq, deleteFavoriteAPIReq, postUserEditableDataAPIReq, ActivateAccountAPIReq, SignUpAPIReq,
  getOffers, getUnvalidatedOffers, postValidateOffer, getNumberOfNumberOffers, postRejectOffer, postDeletePostAPIReq, GetInterestedStudentsAPIReq, getMyApplications, postTipCreationAPIReq, getTipsAPICall, getDashboardData, postIsInterestedUpdate, postDeleteApplications, getCompaniesAPIReq, getProfilesDetailsAPIReq, postOfferAPIReq, getUserEditableDataAPIReq,
  GetAccountInfo, getMyOffers, directPasswordUpdateAPIReq, getFavoritesAPIReq, postRemoveProfilePictureAPIReq, SignInOfficeAPIReq, SignOutAPIReq, SignUpOfficeAPIReq, postChangeProfilePictureAPIReq, postChangeCVAPIReq, postApplyToOfferAPIReq, getCompanyDetailsAPIReq, getOfferDetailsAPIReq};



